import type { CookieKey } from "./types/cookieKey.types";
import type { DeleteCookieProps } from "./utils/deleteCookie";
import { deleteCookie } from "./utils/deleteCookie";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const COOKIE_KEY_REFRESH_TOKEN: CookieKey = "hlwrfh";

export type DeleteCookieRefreshTokenProps = Omit<DeleteCookieProps, "key">;

export const deleteCookieRefreshToken = ({
  ...props
}: DeleteCookieRefreshTokenProps = {}) =>
  deleteCookie({ key: COOKIE_KEY_REFRESH_TOKEN, ...props });

export type GetCookieRefreshTokenProps = Omit<GetCookieProps, "key">;

export const getCookieRefreshToken = ({
  ...props
}: GetCookieRefreshTokenProps = {}) =>
  getCookie({ key: COOKIE_KEY_REFRESH_TOKEN, ...props });

export type SetCookieRefreshTokenProps = Omit<SetCookieProps, "key">;

export const setCookieRefreshToken = ({
  ...props
}: SetCookieRefreshTokenProps) =>
  setCookie({ key: COOKIE_KEY_REFRESH_TOKEN, ...props });
